<script>
import MultipleRadios from "@/pages/components/form/input-only/multiple-radios.vue";

export default {
  components: {MultipleRadios},
  inheritAttrs: false,
  emits: ['update:modelValue'],
  props: {
    'modelValue': {
      required: true,
    },
    'name': {
      required: true,
      type: String,
    },
    'label': {
      required: true,
      type: String,
    },
    'extra': {
      required: false,
      type: String,
    },
    'groupClasses': {
      type: String,
      required: false,
    },
    'required': {
      type: Boolean,
      default: true,
    },
  },
}
</script>

<template>
  <div class="form-group row" :class="{[groupClasses] : typeof groupClasses != 'undefined'}">
    <label class="col-6 form-label">{{ label }}</label>
    <label v-if="extra" class="col-6 form-label">{{ extra }}</label>

    <div class="col-6">
      <MultipleRadios
          v-bind="$attrs"
          :name="name"
          :model-value="modelValue"
          :required="required"
          :options="[
            {label: '0 - 6000 N', value: '0_6000_N'},
            {label: '0 - 10500 N', value: '0_10500_N'},
          ]"
          @update:modelValue="this.$emit('update:modelValue', $event)"
      />
    </div>
  </div>
</template>